import $ from 'jquery';
import CountUp from 'countup.js';
require( 'waypoints/lib/noframework.waypoints.min' );

var options = {
  useEasing: true,
  useGrouping: false,
  separator: ',',
  decimal: '.',
};

var countUpClinical = new CountUp( 'js--countup-clinical', 0, 20, 0, 10, options );
var countUpProducts = new CountUp( 'js--countup-products', 0, 15, 0, 10, options );
var waypoint;
var waypointFunct
var sectionProducts = $('.section--products')
$( document ).ready( function(){
  if( $( '#section--products' ) ) {
    countUpClinical.start();
    countUpProducts.start();
    // new Waypoint({
    //     element: document.getElementById('section--products'),
    //     handler: function() {
    //       countUpClinical.start();
    //       countUpProducts.start();
    //     },
    //     offset: '80%'
    //   });
      }
  else {
    // new Waypoint( {
    //   element: document.querySelector( 'section' ),
    //   handler: function() {},
    //   offset: 0
    // }
    //
    // )
  }

});
